/* eslint-disable indent */
import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'
import { Box } from '@chakra-ui/react'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
  color?: string
}

const ToothbrushIconOutline = createIcon({
  displayName: 'ToothbrushIconOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <path d="M0 0h24v24h-24v-24Z"></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M4.512 20.489v0c-.683-.681-.683-1.784 0-2.465l13.504-13.513c.683-.681 1.789-.681 2.472 8.88178e-16v0c.683.681.683 1.784 0 2.465l-13.504 13.513c-.683.681-1.789.681-2.472 0Z"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M13.183 9.347l-1.941-1.941c-.322-.322-.322-.845 0-1.167l3.997-3.997c.322-.322.845-.322 1.167 0l1.973 1.973"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M6.5 6c0-.828.672-1.5 1.5-1.5 -.828 0-1.5-.672-1.5-1.5 0 .828-.672 1.5-1.5 1.5 .828 0 1.5.672 1.5 1.5Z"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M3.5 13c0-.828.672-1.5 1.5-1.5 -.828 0-1.5-.672-1.5-1.5 0 .828-.672 1.5-1.5 1.5 .828 0 1.5.672 1.5 1.5Z"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M18 21c0-1.657 1.343-3 3-3 -1.657 0-3-1.343-3-3 0 1.657-1.343 3-3 3 1.657 0 3 1.343 3 3Z"
        ></path>
      </g>
    </>
  ),
})

const ToothbrushIconTwoTone = createIcon({
  displayName: 'ToothbrushIconTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <path d="M0 0h24v24h-24v-24Z"></path>
        <Box
          as="path"
          stroke="twoToneStrokeColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M4.512 20.489v0c-.683-.681-.683-1.784 0-2.465l13.504-13.513c.683-.681 1.789-.681 2.472 8.88178e-16v0c.683.681.683 1.784 0 2.465l-13.504 13.513c-.683.681-1.789.681-2.472 0Z"
        ></Box>
        <Box
          as="path"
          stroke="twoToneStrokeColor"
          fill="twoToneFillColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M13.183 9.347l-1.941-1.941c-.322-.322-.322-.845 0-1.167l3.997-3.997c.322-.322.845-.322 1.167 0l1.973 1.973"
        ></Box>
        <Box
          as="path"
          stroke="twoToneStrokeColor"
          fill="twoToneFillColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M6.5 6c0-.828.672-1.5 1.5-1.5 -.828 0-1.5-.672-1.5-1.5 0 .828-.672 1.5-1.5 1.5 .828 0 1.5.672 1.5 1.5Z"
        ></Box>
        <Box
          as="path"
          stroke="twoToneStrokeColor"
          fill="twoToneFillColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M3.5 13c0-.828.672-1.5 1.5-1.5 -.828 0-1.5-.672-1.5-1.5 0 .828-.672 1.5-1.5 1.5 .828 0 1.5.672 1.5 1.5Z"
        ></Box>
        <Box
          as="path"
          stroke="twoToneStrokeColor"
          fill="twoToneFillColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M18 21c0-1.657 1.343-3 3-3 -1.657 0-3-1.343-3-3 0 1.657-1.343 3-3 3 1.657 0 3 1.343 3 3Z"
        ></Box>
      </g>
    </>
  ),
})

const Toothbrush: FC<CustomIconProps> = (props) => {
  switch (props.variant || 'outline') {
    case 'twoTone':
      return <CustomIcon as={ToothbrushIconTwoTone} {...props} />
    default:
      return <CustomIcon as={ToothbrushIconOutline} {...props} />
  }
}

export default memo(Toothbrush)
